'use client';

import Logo from '@/components/logo/Logo';
import classNames from 'classnames';

import classes from './footer.module.scss';

export default function SGFooter({ className }: { className?: string }) {
  return (
    <footer className={classNames(classes.styleGuideFooter, className)} data-testid="style-guide-footer">
      <Logo />
    </footer>
  );
}
